import React from "react";
import { Dropdown } from "components/ui";
import { ReactSVG } from "react-svg";
import asset from "assets/images";
import { TEAM_MEMBER_ACTIONS } from "../enums";
import { TEAM_MEMBER_DELETE_PERMISSION } from "../../../../permissions";

const TeamMemberDropdown = ({ member, handleActionModal }) => {
    return (
        <Dropdown
            size='sm'
            placeholder={
                <ReactSVG
                    src={asset?.icons?.horizontalEllipsis}
                    className='d-inline-flex'
                />
            }
            ddValueClass='borderless'
            className='table__dropdown'
            ddOptionsClass='table__dropdown'
            anchor={false}
            changeValue={false}
            onChange={({ value }) => handleActionModal(value, member)}
            options={[
                {
                    value: TEAM_MEMBER_ACTIONS.REMOVE_MEMBER,
                    label: "Remove Member",
                    baseResources: TEAM_MEMBER_DELETE_PERMISSION,
                },
            ]}
        />
    );
};

export default TeamMemberDropdown;
